import { render, staticRenderFns } from "./tao3.vue?vue&type=template&id=3f19423b&scoped=true&"
import script from "./tao3.vue?vue&type=script&lang=js&"
export * from "./tao3.vue?vue&type=script&lang=js&"
import style0 from "./tao3.vue?vue&type=style&index=0&id=3f19423b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f19423b",
  null
  
)

export default component.exports